import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Service, serviceService } from "~/services/firebaseService";
import AppLayout from "~/pages/AppLayout/AppLayout";
import { Card } from "~/components/Card";

export default function Services() {
  const { t } = useTranslation();
  const [services, setServices] = useState<Service[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    async function fetchData() {
      try {
        const fetchedData = await serviceService.getAllServices();
        setServices(fetchedData);
      } catch (err) {
        setError("Failed to fetch services");
        console.error("Error fetching services:", err);
      } finally {
        setLoading(false);
      }
    }

    fetchData();
  }, []);

  const handleRetry = () => {
    setError(null);
    setLoading(true);
    const fetchData = async () => {
      try {
        const fetchedData = await serviceService.getAllServices();
        setServices(fetchedData);
      } catch (err) {
        setError("Failed to fetch services");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  };

  return (
    <AppLayout
      title={t("services.title")}
      loading={loading}
      error={error}
      emptyTitle="No Services Available"
      emptyMessage="We're working on adding new services. Please check back soon!"
      onRetry={handleRetry}
    >
      {services.map((service) => (
        <Card
          key={service.id}
          id={service.id!}
          title={service.title}
          description={service.shortDescription}
          image={service.image}
          href={`/services/${service.id}`}
          category={service.category}
          // meta={{
          //   price: `$${service.price}`,
          //   badge: service.duration
          // }}
        />
      ))}
    </AppLayout>
  );
}
